export default __webpack_public_path__ + "static/media/googlePlayBadge.194cc0b8.png";